import { compose, withHandlers } from 'recompose';
import { withTranslation } from 'react-i18next';

import { actions as shipmentsActions } from 'state/shipments';
import { selectors as orderSelectors } from 'state/order';
import { connect } from 'react-redux';

import MRStops from 'components/form/MRStops/component';

const enhance = compose(
  withTranslation('Stop'),
  connect(
    (state) => ({
      loadsInForm: orderSelectors.getLoadsInForm(state),
      maxReached: orderSelectors.getMaxReached(state),
      isEditing: orderSelectors.getIsEditing(state),
    }),
    {
      createShipment: shipmentsActions.createShipment,
    }
  ),
  withHandlers({
    handleAddShipment:
      ({ createShipment, typeOfOrder }) =>
      () => {
        createShipment({ orderType: typeOfOrder });
      },
  })
);

export default enhance(MRStops);
